import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'
import EventEmitter, {
  SHOW_TOAST_MESSAGE,
} from '../../../../helpers/EventEmitter'
import {
  TranslateDeletePortfolio,
  TranslateItemSelect,
} from '../../../common/html/text/TranslateItem'
import { TYPE_DELETE } from '../../../constant'
import { checkIsSelectAll, getListIdSelectByObj } from '../../../helper'
import { putUpdateAlertCompany } from '../../detailsPortfolios/store/thunk'
import { DeleteCompanyInPortfolio } from '../components/DeleteCompanyInPortfolio'
import { DeletePortfolio } from '../components/DeletePortfolio'
import { PORTFOLIO_VALUES } from '../constant'
import style from '../index.module.scss'
import {
  removeIdInListIdAll,
  selectAllIdByTerm,
  selectCheckboxPortfolio,
  selectIDCompanySearch,
  unSelectAllCheckbox,
} from '../store/slice/slice'
import {
  changeFragment,
  selectNameCompanySearch,
  selectTypePortfolioSelect,
} from '../store/slice/sliceComponent'
import { delDeletePortfolio, getHeaderSavedPortfolio } from '../store/thunk'

export const InteractiveTable = ({ ids, typeSelect }) => {
  const dispatch = useDispatch()

  const idCompanySearch = useSelector(selectIDCompanySearch)
  const nameCompany = useSelector(selectNameCompanySearch)
  const typeSearch = useSelector(selectTypePortfolioSelect)
  const checkboxObj = useSelector(selectCheckboxPortfolio(['listIdsSelected']))
  const listIdAllByTerm = useSelector(
    selectCheckboxPortfolio(['listIdAllByTerm']),
  )

  const isShowInteractive = Object.values(checkboxObj).some(Boolean)
  const numberIdSelected = Object.values(checkboxObj).reduce(
    (accumulator, currentValue) =>
      currentValue ? accumulator + currentValue : accumulator,
    0,
  )
  const isSelectAllIdByTerm = checkIsSelectAll(listIdAllByTerm, checkboxObj)

  const [isShowDelete, setIsShowDelete] = useState(false)
  const [isShowDeleteCompany, setIsShowDeleteCompany] = useState(false)

  const handleDelete = () => {
    setIsShowDelete(true)
  }

  const handleUnSelectAllPortfolio = () => {
    dispatch(unSelectAllCheckbox())
  }

  const handleSelectAllPortfolio = (value) => {
    dispatch(selectAllIdByTerm(value))
  }

  const handelDeleteCompanyInPortfolio = () => {
    setIsShowDeleteCompany(true)
  }

  const handleConfirmDelete = () => {
    dispatch(
      delDeletePortfolio({
        portfolioIds: getListIdSelectByObj(checkboxObj),
        deleteType: TYPE_DELETE.IN,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(changeFragment())
        setIsShowDelete(false)
        dispatch(getHeaderSavedPortfolio({}))
        handleUnSelectAllPortfolio()
        dispatch(removeIdInListIdAll(getListIdSelectByObj(checkboxObj)))
      })
      .catch(() => {})
  }

  const handelActiveAlert = () => {
    dispatch(
      putUpdateAlertCompany({
        portfolioIds: getListIdSelectByObj(checkboxObj),
        organizationIds: [idCompanySearch],
        alertStatusId: true,
      }),
    )
      .unwrap()
      .then(() => {
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: (
            <Translate
              value="library.main.TOAST_MESS_ON_ALERT"
              name={nameCompany}
            />
          ),
        })
      })
      .catch(() => {
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: <Translate value="library.main.TOAST_ERROR" />,
        })
      })
  }

  const handelUnActiveAlert = () => {
    dispatch(
      putUpdateAlertCompany({
        portfolioIds: getListIdSelectByObj(checkboxObj),
        organizationIds: [idCompanySearch],
        alertStatusId: false,
      }),
    )
      .unwrap()
      .then(() => {
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: (
            <Translate
              value="library.main.TOAST_MESS_OFF_ALERT"
              name={nameCompany}
            />
          ),
        })
      })
      .catch(() => {
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: <Translate value="library.main.TOAST_ERROR" />,
        })
      })
  }

  useEffect(() => {
    handleUnSelectAllPortfolio()
  }, [typeSearch])

  return (
    <>
      {isShowInteractive && (
        <Element
          className={['dFlex alignItemsCenter', style.listActionIcon].join(' ')}
        >
          <Element elementName="p" className="fw600">
            <TranslateItemSelect count={numberIdSelected} />
          </Element>
          {isSelectAllIdByTerm ? (
            <Element
              elementName="p"
              className="fw600 cursorPointer"
              style={{
                color: '#2C73E8',
              }}
              onClick={() => handleUnSelectAllPortfolio()}
            >
              <Translate value="library.main.UNSELECT_ALL" />
            </Element>
          ) : (
            <Element
              elementName="p"
              className="fw600 cursorPointer"
              style={{
                color: '#2C73E8',
              }}
              onClick={() => handleSelectAllPortfolio(true)}
            >
              <Translate
                value="library.main.SELECT_ALL"
                count={listIdAllByTerm?.length}
              />
            </Element>
          )}

          <Tooltip isI18n tooltipContent="library.main.DELETE">
            <Element
              className={style.icon}
              style={{ backgroundColor: '#f2f7ff' }}
              onClick={handleDelete}
            >
              <Icon
                style={{ color: '#2C73E8', fontSize: 15 }}
                className="icon-trash-fill"
              />
            </Element>
          </Tooltip>

          {typeSelect.value === PORTFOLIO_VALUES.COMPANY &&
            !!idCompanySearch && (
              <>
                <Tooltip isI18n tooltipContent="library.main.REMOVE_COMPANY">
                  <Element
                    className={style.icon}
                    style={{ backgroundColor: '#f2f7ff' }}
                    onClick={handelDeleteCompanyInPortfolio}
                  >
                    <Icon
                      style={{ color: '#2C73E8', fontSize: 15 }}
                      className="icon-trash-sweep"
                    />
                  </Element>
                </Tooltip>

                <Tooltip isI18n tooltipContent="library.main.TURN_ON_ALERT">
                  <Element
                    className={style.icon}
                    style={{ backgroundColor: '#f2f7ff' }}
                    onClick={handelActiveAlert}
                  >
                    <Icon
                      style={{ color: '#3DA967', fontSize: 15 }}
                      className="icon-notifications"
                    />
                  </Element>
                </Tooltip>

                <Tooltip isI18n tooltipContent="library.main.TURN_OF_ALERT">
                  <Element
                    className={style.icon}
                    style={{ backgroundColor: '#f2f7ff' }}
                    onClick={handelUnActiveAlert}
                  >
                    <Icon
                      style={{ color: '#9C9C9C', fontSize: 15 }}
                      className="icon-notifications-off"
                    />
                  </Element>
                </Tooltip>
              </>
            )}
        </Element>
      )}

      {isShowDelete && (
        <DeletePortfolio
          isShow={isShowDelete}
          setShow={setIsShowDelete}
          handleDelete={handleConfirmDelete}
          renderContent={() => (
            <>
              <Element elementName="p" style={{ overflowWrap: 'break-word' }}>
                {!isSelectAllIdByTerm ? (
                  <TranslateDeletePortfolio count={numberIdSelected} />
                ) : (
                  <Translate value="library.savePortfolio.TEXT_DELETE_ALL_PORTFOLIOS" />
                )}
              </Element>
            </>
          )}
        />
      )}
      {isShowDeleteCompany && (
        <DeleteCompanyInPortfolio
          isShow={isShowDeleteCompany}
          setShow={setIsShowDeleteCompany}
          listIdsSelected={getListIdSelectByObj(checkboxObj)}
          countItems={numberIdSelected}
          idCompanySearch={idCompanySearch}
          functionClear={handleUnSelectAllPortfolio}
        />
      )}
    </>
  )
}
